import React, { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';

import styles from './styles.module.scss';
import { getItineraryUrlParams, getRoutes } from './utils';

import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@Redux/search/store';
import { setSearchPrice, setSearchInfoCalendar, setUrlparams } from '@Redux/search/actions';

import { SearchIcon } from '@features/ui/Icons';
import SlidePage from '@features/ui/SlidePage';
import BreadCrumb from '@features/ui/BreadCrumb';
import SearchPanelContent from './components/SearchPanelContent';
import SearchPlaceHolder from './components/SearchPlaceHolder';

interface I_SearchPanelProps {
    isOpenPanelM: boolean,
    openPanelM: () => void,
    closePanelM: () => void
}

const SearchPanel = ({ isOpenPanelM, openPanelM, closePanelM }: I_SearchPanelProps) => {
    const dispatch = useDispatch();
    const { SearchPrice } = useSelector((state: RootState) => state.search);
    // const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    const routes = getRoutes(SearchPrice);

    // TODO: 待確認同步外部系統做法
    // useEffect(() => {
    //     if (!location.search && isMobile) openPanelM();
    // }, [isMobile, openPanelM]);

    // TODO: 待確認同步外部系統做法
    useEffect(() => {
        if (!location.search) return;
        const urlParams = getItineraryUrlParams();
        dispatch(setUrlparams(urlParams));

        // TODO: 修改打 API 的方式
        if (location.search.length > 0) {
            dispatch(setSearchPrice(urlParams));
        }
    }, [dispatch]);

    return (
        <div className={styles.searchPanelWrap}>
            <div className="container">
                <BreadCrumb routes={routes} />
                <SearchPanelContent device="PC" />
                <h1 className={styles.header}>國際機票</h1>
                <div className={styles.searchBarM} onClick={openPanelM}>
                    <SearchIcon />
                    <div>
                        <SearchPlaceHolder />
                    </div>
                </div>
                <SlidePage title="國際機票" visible={isOpenPanelM} setIsVisible={closePanelM}>
                    <SearchPanelContent device="M" />
                </SlidePage>
            </div>
        </div>
    );
};

export default SearchPanel;
